import React from 'react';
import {  SimpleForm,  TextInput,  SelectInput,  ImageInput,  ImageField,  required,  SaveButton,  Toolbar } from 'react-admin';
import { renderWineFields } from './BoxWine';
import { renderCheeseFields } from './BoxCheese';
import { renderSpiritFields } from './BoxSpirit';
import { renderCoffeeFields } from './BoxCoffee';
import { renderFlowerFields } from './BoxFlower';

const ProvenanceForm = ({ isEdit, productType }) => {

  const CustomToolbar = props => (
    <Toolbar {...props}>
      <SaveButton label="Save" />
    </Toolbar>
  );
  console.log('ProvenanceForm - productType:', productType);
  return (
    <SimpleForm toolbar={<CustomToolbar />} defaultValues={ { data: { productType: productType || "wine" } }} 
      // onSubmit={handleImageUpload}
    >
      <TextInput label="Product Type" 
        source="data.productType" 
        disabled 
        style={{ display: 'none' }}
      />
      <TextInput label="Product Type" 
        source="data.tag_model" 
        defaultValue="NTAG 213 Tag Tamper"
        disabled 
        style={{ display: 'none' }}
      />
      {/* <SelectInput 
        label="Tag Model" 
        source="data.tag_model" 
        choices={[
          { id: 'NTAG 424 DNA Tag Tamper', name: 'NTAG 424 DNA Tag Tamper' },
          { id: 'NTAG 213 Tag Tamper', name: 'NTAG 213 Tag Tamper' },
          { id: 'ST25TV02KC Tag Tamper', name: 'ST25TV02KC Tag Tamper' },
          { id: 'Cryptographic QR-code', name: 'Cryptographic QR-code' }
        ]} 
        defaultValue="NTAG 424 DNA Tag Tamper"
        validate={required()}
      /> */}
      <TextInput 
        source="data.is_tag_tamper" 
        defaultValue={true}
        style={{ display: 'none' }}
        disabled
      />
      {/* Render fields based on product type with fallback to wine */}
      {(!productType || productType === 'wine') && renderWineFields()}
      {productType === 'cheese' && renderCheeseFields()}
      {productType === 'spirit' && renderSpiritFields()}
      {productType === 'coffee' && renderCoffeeFields()}
      {productType === 'flower' && renderFlowerFields()}
      <ImageInput placeholder={<p>Drop the product image here</p>} source="picture" accept={{ 'image/*': ['.png', '.jpg', '.webp'] }} maxSize={750000} multiple={false} label="&nbsp;">
        <ImageField source="src" title="title" />
      </ImageInput>
    </SimpleForm>
  );
};

export default ProvenanceForm;
